module.exports = __webpack_public_path__ + "img/Thunder_Signet.68df871c.png";